"use strict";

//=include  ../../MetricsTracker/booker/metrics.js
import BookerTracker from "../../MetricsTracker/booker/metrics";
import { CalendarAvailability } from "../../utils/pricetravel/shared/calendarAvailability";
import GlobalUtil from "../../utils/pricetravel/shared/globalUtil";
import { StorageService } from '../../vue/services/StorageService';
//import { CookieService } from '../../vue/services/CookieService';
import { SearchHistory } from "../../utils/pricetravel/shared/searchHistory";
window.app.controller("BookerHotelController", controller);
import dayjs from "dayjs";
import { useHotelBookerStore } from '../../vue/stores/hotelBooker';
import pinia from '../../vue/stores/store';
import GoogleMapList from "../../utils/maps/GoogleMapList";

controller.$inject = [
    "$scope",
    "$http",
    "$location",
    "$rootScope",
    "$filter"
];

function controller(
    $scope,
    $http,
    $location,
    $rootScope,
    $filter
) {
    let vm = this;
    let config = window.__pt.settings.site;
    let setting = window.__pt.settings;
    let lang = window.__pt.ln;
    let fn = window.__pt.fn;
    let defaultDate = fn.getDate();
    let _place = window.__pt.place || {};
    let _list = "";
    let _inputName = "";
    let _datePicker = {};
    let _picker = null;
    let tracker = new BookerTracker();
    let box = window.__pt.box || null;
    let localeDatePicker = {
        format: setting.formatBoxDate,
        formatMobile: setting.formatBoxDateMobile,
        firstDay: 0,
        applyLabel: lang.ok,
        cancelLabel: lang.cancel,
    };
    let elements = {};
    let datesQuote = {};
    let _user = window.__pt.user || null;
    let lastQuery = '';
    vm.submit = false;

    let searchModificationCount = 0;
    let hasUrlFilters = false;
    vm.ln =lang;
    let _googleMapNearby = null;
    function triggerLocationPrompt() {
        if (!window.__pt.settings.rb && !_googleMapNearby) {
            _googleMapNearby = new GoogleMapList(vm, $http, $filter, $scope);
            _googleMapNearby.getLocationUser();
        }
    }
    const hotelBookerStore = useHotelBookerStore(pinia);
    vm.hotelBookerStore = hotelBookerStore;
    hotelBookerStore.$subscribe(() => {
        $scope.$evalAsync();
    });
    function getSearchModificationCount() {
        try {
            return parseInt(StorageService.get('searchModificationCount') || '0', 10);
        } catch (e) {
            return 0;
        }
    }

    function incrementSearchModificationCount() {
        const currentCount = getSearchModificationCount();
        const newCount = currentCount + 1;
        StorageService.set('searchModificationCount', newCount.toString());
        return newCount;
    }

    vm.years = [];
    vm.suggestion = {
        from: {
            results: [],
            show: false,
        },
        paxes: false,
    };
    vm.hasResult = false;

    vm.validation = {
        paxes: true,
        checkIn: true,
        checkOut: true,
        dates: true,
    };
    vm.siteUrl = window.__pt.settings.site.siteUrl;
    vm.algoliaUrl = "https://img.cdnpth.com/media/assets/recent-search-imgs/places/";
    vm.settingPaxes = {
        minAdults: 1,
        maxAdults: 30,
        minChildren: 0,
        maxChildren: 24,
        minAge: 0,
        maxAge: 17,
        rooms: 10,
    };

    // get cookies//
    let _globalUtil = new GlobalUtil();
    let _userKey = _globalUtil.getUserKey();
    let configDaysPrequote = {
        weeksPrequote: 0,
        daysPrequote: 0,
        startDate: 0,
    };
    vm.data = setting.defaultHotel;
    vm.display = true;
    vm.keyPosition = 0;
    vm.placeInputHasFocus = false;
    vm.history = [];
    vm.dataCopyCancel = setting.defaultHotel;

    $rootScope.$on(setting.bookerValuesEvent, function (event, args) {

        if (args && args.pax) {
            vm.data.checkIn = fn.getDate(args.checkIn);
            vm.data.checkOut = fn.getDate(args.checkOut);
            vm.data.paxes = args.pax;
            updateWithoutReload();
            $rootScope.$broadcast(setting.bookerChangeEvent, vm.data);
        } else {
            vm.data.place_selected = args.place;
            vm.data.paxes = args.box.pax;
            vm.data.checkIn = fn.getDate(args.box.checkIn);
            vm.data.checkOut = fn.getDate(args.box.checkOut);
            vm.data.campaignTokenApi = args.campaignTokenApi;
            vm.data.campaignToken = args.campaignToken;
            vm.onSubmit(vm.form, true);
        }
    });

    $rootScope.$on(setting.bookerSearchEvent, function (event, args) {
        tracker.metricModifiedSearchRecomendation(args.typeEvent);
        vm.data.paxes = args.paxes;
        vm.data.checkIn = args.checkIn;
        vm.data.checkOut = args.checkOut;
        updateWithoutReload();
        //trigger
        vm.data.typeEvent = args.typeEvent;
        $rootScope.$broadcast(setting.bookerChangeEvent, vm.data);
    });


    vm.onSearch = (value, list, input, focus) => {
        if (value === "" || value === null || value === undefined || value.length < 3) {
            AlgoliaSearch();
        }

        if (!value || (value && value.length < 3)) {
            return;
        }

        vm.hasResult = false;

        if (vm.form[input].$valid) {
            _inputName = focus;
            _list = list;
            const params = {
                query: value,
                language: config.language,
                placeTypes: config.placesTypeHotel,
                from: 0,
                size: 10,
                usersearch: _userKey,
                site: config.code,
                analyticsTags: getAnalyticsTags(),
            };
            $http
                .get(config.endPoints.suggestionHotelUrl, { params })
                .then(function tap(resp) {

                    if (resp.data.length > 0) {
                        const src = resp.data || [];
                        lastQuery = params.query;
                        tracker.metricAutocompleteHotel(params.query, src);
                    }
                    else {
                        tracker.metricAutocompleteHotel(params.query, []);
                    }
                    return resp;
                })
                .then(onSuccessSuggestion, onError);
        }
    };

    vm.onSubmit = function (form, fromEvent = false, btnText = "", isMobileEjec, content) {
        vm.validation.paxes = isValidPax(vm.data.paxes, form);


        if (isMobileEjec && setting.page == "hotel") {
            if (form.$valid && vm.validation.paxes) {
                vm.data.typeEvent = content;
                $rootScope.$broadcast(setting.bookerSearchEvent, vm.data);
                $rootScope.$broadcast(setting.bookerSearchEventSmall, vm.data);
                vm.form.$pristine = false;
                vm.form.$dirty = false;
                vm.form.$submitted = false;
            } else {
                if (!vm.validation.paxes) vm.suggestion.paxes = true;
            }
        } else if (isMobileEjec && setting.page != "hotel") {
            return;
        } else {
            vm.submit = true;
            if (!fromEvent) {
                vm.validation.paxes = isValidPax(vm.data.paxes, form);
                vm.validation.checkIn = isValidDate(defaultDate, vm.data.checkIn);
                vm.validation.checkOut = isValidDate(defaultDate, vm.data.checkOut);
                vm.validation.dates = isValidDate(vm.data.checkIn, vm.data.checkOut);
            } else {
                form.$valid = true;
            }

            if (
                form.$valid &&
                vm.validation.paxes &&
                vm.validation.checkIn &&
                vm.validation.checkOut &&
                vm.validation.dates
            ) {
                let paramsQuery = fn.search();
                let paxesData = MapPaxToUrl(vm.data.paxes);
                let codept = paramsQuery.coupon;

                let data = {
                    adults: vm.data.paxes.adults,
                    checkin: fn.formatDate(vm.data.checkIn, setting.formatDate),
                    checkout: fn.formatDate(vm.data.checkOut, setting.formatDate),
                };

                if (codept) {
                    data.coupon = codept;
                }
                if (vm.data.place_selected.cityUrl && config.algoliaDetailIs) {
                    data.profileId = vm.data.place_selected.code;
                }
                if (paramsQuery.CampaignToken) {
                    data.CampaignToken = paramsQuery.CampaignToken;
                }

                if (paramsQuery.campaignTokenApi) {
                    data.campaignTokenApi = paramsQuery.campaignTokenApi;
                }

                if (paramsQuery.ctInternal) {
                    data.ctInternal = paramsQuery.ctInternal;
                }
                if (paramsQuery.source) {
                    data.source = paramsQuery.source;
                }
                if (vm.data.isNearby) {
                    data.nearby = 1;
                }

                data = { ...data, ...paxesData };

                var path = GetPathUri(vm.data.place_selected.type);

                var hotelIdPath = vm.data.place_selected.type == 14 ? `_a${vm.data.place_selected.code || vm.data.place_selected.id}` : `_d${vm.data.place_selected.id}`;

                searchModificationCount = incrementSearchModificationCount();

                var currentFilters = getCurrentFiltersFromUrl();
                var filtersPath = currentFilters.length > 0 ? `/${currentFilters.join("/")}` : "";

                tracker.metricBookerHotel('booker', { vmData: vm.data, data });
                var form = document.createElement("form");
                form.setAttribute("method", "get");
                form.setAttribute("action", `${config.siteUrl}${path}${vm.data.place_selected.uri}${hotelIdPath}${filtersPath}`);



                for (var key in data) {
                    if (data[key]) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", data[key]);

                        form.appendChild(hiddenField);
                    }
                }

                SearchHistory.set(vm.data, "H");

                $("#loader-page").removeClass("d-none");
                document.body.appendChild(form);
                form.submit();
            } else {
                if (!vm.validation.paxes) vm.suggestion.paxes = true;
            }
        }
    };

    vm.onSelect = (item, type, index, fromHistory = false, sufix = '') => {
        vm.isSelected = true;
        getRestMobile("auto");
        vm.data.isNearby = sufix === '_nearby';
        vm.data.place_name = vm.data.isNearby ? lang.nearby + ' ' + item.displayText : item.displayText;
        vm.data.place_selected = item;
        vm.suggestion[type].show = false;
        vm.placeInputHasFocus = false;

        if (fromHistory) {
            tracker.metricRecentSearch(item.displayText);
        }
        tracker.metricAutocompleteHotelSelect(item, lastQuery, 'autocomplete_destination', sufix);
    };


    vm.showPaxes = () => {
        vm.suggestion.paxes = true;
        vm.dataCopyCancel = angular.copy(vm.data);
        getRestMobile("hidden");
    };

    vm.addRoom = (prop) => {
        if (vm.settingPaxes.rooms <= vm.data.paxes[prop]) {
        } else {
            vm.data.paxes[prop] += 1;
            updateInputPaxes();
        }
    };


    vm.removeRoom = (prop) => {
        if (vm.data.paxes[prop] + 1 > 2) {
            vm.data.paxes[prop] -= 1;
        }
        updateInputPaxes();
    };

    vm.onFocus = (element, input) => {
        triggerLocationPrompt();
        _list = element;
        _inputName = input;
        vm.hasResult = true;
        setTimeout(() => {
            AlgoliaSearch();
        }, 200);

        if (vm.suggestion[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestion[element]["show"] = true;
                    if (fn.mobileAndTabletCheck()) {
                        onFocusElement(`${input}_modal`);
                    }
                });
            }, 250);
        }
    };

    vm.getIcon = (type) => {
        let icon = "icons-globe-outline"; //
        switch (type) {
            case 6:
                icon = "icons-globe-outline"; //
                break;
            case 3:
                icon = "icons-location"; //
                break;
            case 11:
                icon = "icons-plane-airport";
                break;
            case 7:
                icon = "icons-compass"; //
                break;
            case 14:
                icon = "icons-hotel"; //
                break;
            case 12:
                icon = "icons-monument"; //
                break;
        }

        return [icon];
    };

    vm.removePax = (prop, minValue) => {
        if (vm.data.paxes[prop] - 1 >= minValue) {
            vm.data.paxes[prop] -= 1;
        }
        updateInputPaxes();
    };

    vm.addPax = (prop, maxValue) => {
        if (vm.data.paxes[prop] + 1 <= maxValue) {
            vm.data.paxes[prop] += 1;
        }
        updateInputPaxes();
    };

    vm.removeChildren = (prop, minValue) => {
        if (vm.data.paxes[prop].length - 1 >= minValue) {
            vm.data.paxes[prop].splice(vm.data.paxes[prop].length - 1, 1);
        }
        updateInputPaxes();
    };

    vm.addChildren = (prop, maxValue) => {
        if (vm.data.paxes[prop].length + 1 <= maxValue) {
            vm.data.paxes[prop].push({
                year: null,
            });
        }
        updateInputPaxes();
    };

    vm.onClose = (obj, prop) => {
        if (somePaxHasError()) {
            vm.form.$setSubmitted();
            return;
        }
        obj[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus = false;
        getRestMobile("auto");
    };

    vm.onCloseCancel = (obj, prop) => {
        vm.data = vm.dataCopyCancel;
        obj[prop] = false;
        setValidation(prop);
        getRestMobile("auto");
    };

    vm.onCloseSubmitForm = (obj, prop, isSmall) => {
        getRestMobile("auto");
        if (!somePaxHasError() && !vm.form.$invalid) {
            if (isSmall) {
                vm.onClose(obj, prop);
                $rootScope.$broadcast(setting.bookerSearchEvent, vm.data);
                $rootScope.$broadcast(setting.bookerSearchEventSmall, vm.data);
                vm.form.$pristine = false;
                vm.form.$dirty = false;
                vm.form.$submitted = false;
            } else {
                vm.onSubmit(vm.form, false);
            }
        } else {
            vm.onClose(obj, prop);
        }
    };

    vm.onRemove = (obj, prop, index) => {
        obj[prop].splice(index, 1);
        updateInputPaxes();
    };

    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid;
    };

    vm.isInvalidInput = (form, inputName, inputNumber) => {
        return form.$submitted && form[`${inputName}_${inputNumber}`].$invalid;
    };

    vm.onClickOutside = (element, prop) => {
        vm.placeInputHasFocus = false;
        element[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus = false;
        getRestMobile("auto");
    };

    vm.deleteSelection = (input, selection, type, inputFocus) => {
        vm.data[input] = null;
        vm.data[`${selection}${type.length ? "_" + type : ""}`] = {};

        onFocusElement(inputFocus);
    };

    vm.showBooker = () => {
        vm.display = !vm.display;
    };

    vm.keysNavigation = async (evt, type) => {
        let obj = vm.suggestion[type];
        if (obj && obj.results.length && obj.show) {
            if (evt.keyCode == 40) {
                vm.keyPosition =
                    vm.keyPosition < obj.results.length - 1
                        ? vm.keyPosition + 1
                        : vm.keyPosition;
            }
            if (evt.keyCode == 38) {
                vm.keyPosition =
                    vm.keyPosition > 0 ? vm.keyPosition - 1 : vm.keyPosition;
            }
            if (evt.keyCode == 13) {
                evt.preventDefault();
                vm.onSelect(obj.results[vm.keyPosition], type, vm.keyPosition);
                await fn.sleep(100);
                vm.keySelected = 0;
            }
        }
    };

    vm.clickInputInMobile = (focus) => {
        triggerLocationPrompt();
        getRestMobile("hidden");
        _inputName = focus;
        vm.placeInputHasFocus = true;
        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`);
            if (vm.data.place_name && vm.data.place_name.length > 3) {
                setTimeout(() => {
                    const elem = document.getElementById(`${_inputName}_modal`);
                    if (elem) elem.setSelectionRange(0, elem.value.length);
                }, 200);
            }
        }
    };
     //EMIT HACIA MAPA NEARBY
    vm.goToMapNearby = () => {
        $rootScope.$broadcast(setting.bookerGoToMapNearbyEvent, vm.data);
    }
    /***** Private *****/

    function init() {
        searchModificationCount = getSearchModificationCount();
        hasUrlFilters = false;

        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(part => part.length > 0);
        const destinationIndex = pathParts.findIndex(part => /_[da]\d+$/.test(part));

        if (destinationIndex !== -1 && destinationIndex < pathParts.length - 1) {
            const urlFilters = pathParts.slice(destinationIndex + 1);
            if (urlFilters.length > 0) {
                hasUrlFilters = true;
            }
        }

        initialDefaultDate();
        initSearchBox();
        initDatePicker();
        updateInputPaxes();
        getSearchHistory();

        for (let index = vm.settingPaxes.minAge; index <= vm.settingPaxes.maxAge; index++
        ) {
            vm.years.push({ year: index });
        }
    }

    function onSuccessSuggestion(response) {
        const data = response.data || [];
        if (data.length > 0) {
            data.forEach((element) => {
                const [city, ...locationParts] =
                    element.type == 11
                        ? element.displayHtml.split("-").map((part) => part.trim())
                        : element.displayHtml.split(",").map((part) => part.trim());
                element.city =
                    element.type == 11
                        ? `${locationParts
                            .join(", ")
                            .replace(" " + element.code + " ", "")} (${element.code})`
                        : city;
                element.location =
                    element.type === 11
                        ? city.replace(element.code + " ", "")
                        : locationParts.join(", ");
            });
        }
        vm.suggestion[_list]["results"] = data;
        vm.suggestion[_list]["show"] = true;
        vm.placeInputHasFocus = true;

        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`);
        }
    }

    function onError(response) {
        console.log(response);
    }

    function initSearchBox() {
        let paramsData, storageData;

        if (setting.page == "hotels" || setting.page == "hotel") {
            vm.display = !fn.mobileAndTabletCheck();
        }

        if (setting.page != "home") {
            paramsData = getUserSelectionParams();
        } else {
            storageData = SearchHistory.getFirstEntry("H");
        }

        if (storageData) {
            storageData.place_name = null;
            storageData.place_selected = {};
        }

        vm.data = paramsData || storageData || vm.data;

        if (_globalUtil.getIsArray(vm.data.paxes)) {
            vm.data.paxes = _globalUtil.convertPaxesData(vm.data.paxes);
        }

        if (paramsData || storageData) {
            vm.data.checkIn = fn.getDate(vm.data.checkIn);
            vm.data.checkOut = fn.getDate(vm.data.checkOut);

            if (
                +vm.data.checkIn <= +defaultDate ||
                +vm.data.checkOut <= +defaultDate
            ) {
                initialDefaultDate();
            }
        }
    }

    function AlgoliaSearch() {
        const params = {
            analyticsTags: getAnalyticsTags(),
            from: 0,
            language: config.language,
            placeTypes: 0,
            site: config.code,
            size: 5,
            usersearch: _userKey,
            recommendation: true,
        };
        $http
            .get(config.endPoints.suggestionHotelUrl, {
                params: params,
            })
            .then(onSuccessSuggestion, onError);
    }

    function initDatePicker() {
        let paramsQuery = fn.search();
        if (
            (defaultDate < fn.getDate(vm.data.checkOut) ||
                defaultDate >= fn.getDate(vm.data.checkOut)) &&
            box
        ) {
            if (paramsQuery.daysToArrival && paramsQuery.daystostay) {
                let dateFirst = new Date();
                dateFirst.setDate(
                    dateFirst.getDate() + parseInt(paramsQuery.daysToArrival)
                );
                vm.data.checkIn = dateFirst;
                let dateEnd = new Date(dateFirst);
                dateEnd.setDate(dateEnd.getDate() + parseInt(paramsQuery.daystostay));
                vm.data.checkOut = dateEnd;
            } else {
                vm.data.checkIn = fn.getDate(box.checkIn);
                vm.data.checkOut = fn.getDate(box.checkOut);
            }
        }

        onInitPicker(
            ["calendar-checkIn-hotel", "calendar-checkOut-hotel"],
            vm.data.checkIn,
            vm.data.checkOut,
            "checkIn",
            "checkOut"
        );
    }
    function onInitPicker(element, startDate, endDate, checkIn, checkOut) {
        var pathName = _globalUtil.getFirstPathSegment();
        var css = !setting.rb
            ? [
                `${config.cloudCdn}/assets/css/dist/${config.siteName
                }/booker.css?id=${+new Date()}`,
            ]
            : [];
        _datePicker = {
            element: document.getElementById(element[0]),
            css: css,
            zIndex: 10,
            grid: 2,
            calendars: 768 <= window.innerWidth ? 2 : 1,
            autoApply: true,
            readonly: true,
            lang: config.culture,
            date: startDate,
            format:
                fn.mobileAndTabletCheck() && pathName == "hotel"
                    ? localeDatePicker.formatMobile
                    : localeDatePicker.format,
            plugins: ["RangePlugin", "LockPlugin"],
            LockPlugin: {
                minDate: defaultDate,
                minDays: 2,
            },
            RangePlugin: {
                tooltip: true,
                startDate: startDate,
                endDate: endDate,
                tooltipNumber(num) {
                    return num - 1;
                },
                locale: {
                    one: lang.night,
                    other: lang.night + "s",
                },
            },
            setup(picker) {
                picker.on("render", (e) => {
                    const nextButtons = picker.ui.container.querySelectorAll(".calendars .next-button");
                    const prevButtons = picker.ui.container.querySelectorAll(".calendars .previous-button");
                    if (nextButtons) {
                        nextButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Siguiente mes');
                        });
                    }
                    if (prevButtons) {
                        prevButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Anterior mes');
                        });
                    }
                });
                picker.on("select", (e) => {
                    const { start, end } = e.detail;
                    vm.data[checkIn] = start.toJSDate();
                    vm.data[checkOut] = end.toJSDate();
                    vm.onSubmit(vm.form, true, "", true, "recomendacion");
                });
                picker.on("view", (evt) => {
                    const { view, date, target } = evt.detail;
                    if (view === "CalendarDay") {
                        const placeSelected = vm.data.place_selected;
                        const label = date.format("YYYY_MM");
                        const property = date.format("YYYY-MM-DD");

                        datesQuote[label] = label;

                        elements[property] = {
                            date: date.format("YYYY-MM-DD"),
                            target: target,
                        };

                        let memory = CalendarAvailability.getMemoryDate(
                            label,
                            property,
                            placeSelected.code || placeSelected.id
                        );
                        if (memory) {
                            CalendarAvailability.buildElement(elements[property], memory);
                        }
                    }

                    if (view === "Main") {
                        CalendarAvailability.setFooterElement(target);
                        CalendarAvailability.footerBuild();
                    }
                });

                picker.on("show", (evt) => {
                    getAvailability();
                    CalendarAvailability.overFlow();
                });

                picker.on("hide", (evt) => {
                    CalendarAvailability.overFlow();
                    elements = {};
                    datesQuote = {};
                });

                picker.on("click", (e) => {
                    if (picker.isCalendarHeaderButton(e.target)) {
                        elements = {};
                        datesQuote = {};

                        setTimeout(() => {
                            getAvailability();
                        }, 100);
                    }

                    if (picker.isCalendarDay(e.target)) {
                        setTimeout(() => {
                            getAvailability();
                        }, 100);
                    }
                });
            },
        };
        /** Manejar error por casos de bots de google con incompatibilidad de su bot con nueva versiones de JS */
        try {
            _picker = new easepick.create(_datePicker);
        } catch (e) {
            const input = document.getElementById(element[0]);

            if (!input) return;
            if (startDate && endDate) {
                input.value = `${formatDate(startDate)} - ${formatDate(endDate)}`;
            } else if (startDate) {
                input.value = formatDate(startDate);
            }
        }
    }

    function formatDate(date) {
        const d = date.toJSDate ? date.toJSDate() : date;
        return dayjs(d).format("D MMM YYYY");
    }

    function getUserSelectionParams() {
        let params = fn.search();
        let data = {};
        let place = _place;
        data.place_name = place.displayText || "";
        data.place_selected = place;
        data.checkIn = params.checkin || vm.data.checkIn;
        data.checkOut = params.checkout || vm.data.checkOut;
        let box = window.__pt && window.__pt.box;
        data.paxes = (box && box.pax) ? box.pax : vm.data.paxes;

        return data;
    }

    function initialDefaultDate() {
        if (fn.mobileAndTabletCheck()) {
            configDaysPrequote.weeksPrequote =
                config.configDaysPrequoteMobile.weeksPrequote;
            configDaysPrequote.daysPrequote =
                config.configDaysPrequoteMobile.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteMobile.startDate;
        } else {
            configDaysPrequote.weeksPrequote =
                config.configDaysPrequoteDesktop.weeksPrequote;
            configDaysPrequote.daysPrequote =
                config.configDaysPrequoteDesktop.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteDesktop.startDate;
        }
        const newDateParse = new Date(defaultDate);
        newDateParse.setDate(
            newDateParse.getDate() + configDaysPrequote.weeksPrequote * 7
        );
        newDateParse.setDate(
            newDateParse.getDate() -
            newDateParse.getDay() +
            configDaysPrequote.startDate
        );

        vm.data.checkIn = getInitialDate(newDateParse);
        vm.data.checkOut = getInitialDate(
            newDateParse,
            configDaysPrequote.daysPrequote
        );
    }

    function getInitialDate(date = fn.getDate(), value = 0) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value);
        return dateNew;
    }

    function updateInputPaxes() {
        let adults = 0;
        let children = 0;
        if (_globalUtil.getIsArray(vm.data.paxes)) {
            for (const room of vm.data.paxes) {
                adults += room.adults || 0;
                children += room.children ? room.children.length : 0;
            }
        } else if (typeof vm.data.paxes === "object") {
            adults = vm.data.paxes.adults || 0;
            children = vm.data.paxes.children ? vm.data.paxes.children.length : 0;
        }

        const lengthPax = _globalUtil.getIsArray(vm.data.paxes)
            ? vm.data.paxes.length
            : vm.data.paxes.rooms;
        const roomTitle = lengthPax === 1 ? lang.room : lang.rooms;
        const adultsTitle = adults === 1 ? lang.adult : lang.adults;
        const childrenTitle = children === 1 ? lang.child : lang.children;

        let childrenText = "";
        if (children > 0) {
            childrenText = ` ${children} ${childrenTitle}, `;
        }

        vm.data.paxes_name = `${adults} ${adultsTitle},${childrenText} ${lengthPax} ${roomTitle}`;
        vm.data.paxes_people = `${adults + children} ${lang.new_pers
            } ${lengthPax} ${lang.new_room}`;
        vm.data.capacityTotal = adults + children;
    }

    function GetPathUri(type) {
        let uri = config.pathHome;
        switch (type) {
            case 6:
                uri = config.pathHoteles;
                break;
            case 3:
                uri = config.pathHoteles;
                break;
            case 11:
                uri = config.pathHoteles;
                break;
            case 7:
                uri = config.pathHoteles;
                break;
            case 14:
                uri = config.pathHotelDetail;
                break;
            case 12:
                uri = config.pathHoteles;
                break;
        }

        return uri;
    }
    function MapPaxToUrl(paxData) {
        let paxesKeys = {};
        let adults = paxData.adults;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        paxesKeys["group_adults"] = adults;
        paxesKeys["no_rooms"] = paxData.rooms;
        if (paxData.children && paxData.children.length > 0) {
            kids = paxData.children.length;
            paxesKeys["group_children"] = kids;

            for (const child of paxData.children) {
                agekids.push(child.year);
                if (child.year > 5) {
                    kids += 1;
                } else {
                    infants += 1;
                }
            }
        }
        if (agekids.length > 0) {
            paxesKeys["age"] = agekids.join(",");
        }
        if (infants > 0) {
            paxesKeys["infant"] = infants;
        }
        return paxesKeys;
    }

    function isValidPax(vmDataPaxes, form) {
        let valid = true;
        const childrens = vmDataPaxes.children.length;
        for (let c = 0; c < childrens; c++) {
            const inputKid = form[`children_${c}`];
            if (inputKid && inputKid.$invalid) {
                valid = false;
                break;
            }
        }
        return valid;
    }

    function isValidDate(dateFrom, dateTo) {
        let valid = true;

        dateFrom.setHours(0, 0, 0, 0);

        if (+dateFrom > +dateTo) {
            valid = false;
        }
        return valid;
    }

    function onFocusElement(nameDiv) {
        setTimeout(() => {
            let element = nameDiv && document.getElementById(nameDiv);
            if (element) {
                element.focus();
            }
        }, 200);
    }

    function setValidation(prop) {
        if (prop == "paxes") {
            vm.validation.paxes = isValidPax(vm.data.paxes, vm.form);
        }
    }

    function somePaxHasError() {
        if (vm.data && vm.data.paxes) {
            const pax = vm.data.paxes;
            if (pax && pax.children && pax.children.length > 0) {
                if (
                    pax.children.some(
                        (child) => child.year === null || child.year === undefined
                    )
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    function getSearchHistory() {
        vm.history = SearchHistory.getHotel("H");
    }

    function getAnalyticsTags() {
        var arrTags = [];
        if (fn.mobileAndTabletCheck()) {
            arrTags.push("web_mobile");
        } else {
            arrTags.push("web_desktop");
        }
        var pathName = _globalUtil.getFirstPathSegment();
        if (pathName == "hotel") {
            arrTags.push("detail");
        } else if (
            (pathName == "hoteles" || pathName == "hotels") &&
            setting.page == "home"
        ) {
            arrTags.push("home");
        } else if (
            (pathName == "hoteles" || pathName == "hotels") &&
            setting.page == "hotels"
        ) {
            arrTags.push("list");
            arrTags.push(window.location.pathname.split("/")[2]);
        } else if (setting.page == "landings") {
            arrTags.push("landings");
        } else {
            arrTags.push("home");
        }
        return arrTags.join(",");
    }

    function updateWithoutReload() {
        _picker.setDateRange(vm.data.checkIn, vm.data.checkOut);
        updateInputPaxes();

        searchModificationCount = incrementSearchModificationCount();

        var currentFilters = getCurrentFiltersFromUrl();

        $location.url($location.path());

        let paramsQuery = fn.search();
        let paxesData = MapPaxToUrl(vm.data.paxes);

        let campaignTokenApi =
            paramsQuery.campaignTokenApi ||
            paramsQuery.CampaignTokenApi ||
            paramsQuery.campaigntokenapi ||
            null;
        let _campaignToken =
            paramsQuery.CampaignToken ||
            paramsQuery.campaignToken ||
            campaignTokenApi;

        let data = {
            placeId: vm.data.place_selected.id,
            placeType: vm.data.place_selected.type,
            adults: vm.data.paxes.adults,
            checkin: fn.formatDate(vm.data.checkIn, setting.formatDate),
            checkout: fn.formatDate(vm.data.checkOut, setting.formatDate),
            campaignToken: _campaignToken ? _campaignToken : null,
        };

        data = data = { ...data, ...paxesData };

        //update uri
        for (var key in data) {
            if (data[key]) {
                $location.search(key, data[key]);
            }
        }

        if (currentFilters.length > 0) {
            const currentPath = $location.path();
            const pathParts = currentPath.split('/').filter(part => part.length > 0);
            const destinationIndex = pathParts.findIndex(part => /_[da]\d+$/.test(part));

            if (destinationIndex !== -1) {
                const basePathParts = pathParts.slice(0, destinationIndex + 1);
                const newPath = '/' + basePathParts.concat(currentFilters).join('/');
                $location.path(newPath);
            }
        }
    }
    function getRestMobile(overflow) {
        if (window.innerWidth <= 479) {
            if (overflow == "auto") {
                document.body.classList.remove("modal-open");
            } else if (overflow == "hidden") {
                document.body.classList.add("modal-open");
            }
        } else {
            document.body.classList.remove("modal-open");
        }
    }

    let getAvailability = async () => {
        if (config.showCalendarAvailability) {
            let placeSelected = vm.data.place_selected;
            if (
                placeSelected &&
                placeSelected.type == 14 &&
                (placeSelected.code || placeSelected.id)
            ) {
                CalendarAvailability.setCalendarPriceContainer();
                for (let calendar in datesQuote) {
                    let calendarData = calendar.split("_");
                    let response = await CalendarAvailability.getAvailability(
                        placeSelected.code || placeSelected.id,
                        calendarData[0],
                        calendarData[1]
                    );
                    CalendarAvailability.build(elements, response);
                }
                CalendarAvailability.footerBuild();
            }
        }
    };

    function getCurrentFiltersFromUrl() {
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(part => part.length > 0);

        const destinationIndex = pathParts.findIndex(part => /_[da]\d+$/.test(part));

        if (destinationIndex !== -1 && destinationIndex < pathParts.length - 1) {
            const urlFilters = pathParts.slice(destinationIndex + 1);

            if (!hasUrlFilters && urlFilters.length > 0) {
                hasUrlFilters = true;
            }

            const currentCount = getSearchModificationCount();

            if (hasUrlFilters && currentCount === 1) {
                return urlFilters;
            } else if (currentCount >= 2) {
                return [];
            } else if (currentCount === 0) {
                return urlFilters;
            }

            return urlFilters;
        }

        return [];
    }

    init();
}
